import { assert } from './assert-sidecar'
import { l } from './imports'

const _onces: string[] = []
export const ensureCalledOnlyOnce = (key: string) => {
  assert.notEmptyString(key)
  key = key.trim()
  if (l.includes(_onces, key)) {
    assert.failed('ensureCalledOnlyOnce failed', key)
  }
  _onces.push(key)
}
